import Service from '@ember/service';

import { service } from '@ember/service';
import { trackedFunction } from 'reactiveweb/function';

import { filterFilter, filterRename, filtersSort, filterTypes } from 'rise-ui/utils/model/filter.js';
import { latest, readOnly } from 'rise-ui/utils/object/computed.js';

const hiddenFilters = filterTypes([]);
const filterOrder = filterTypes([
  // Uncomment and order as sort is desired
  // 'region',
  // 'location-type',
  // 'theme',
  // 'state',
  // 'item-type',
  // 'unified-region',
]);

export default class CatalogFiltersService extends Service {
  @service('model/catalog-filters') catalogFilters;
  @service ssr;

  filterFilter = filterFilter(hiddenFilters);
  filtersSort = filtersSort(filterOrder);

  _filters = trackedFunction(this, async () => {
    if (this.ssr.isSsr) {
      return;
    }
    return (await this.catalogFilters.fetch())
      .map(filterRename)
      .filter(this.filterFilter)
      .sort(this.filtersSort);
  });
  @latest('_filters') filters;
}
